// extracted by mini-css-extract-plugin
module.exports = {"title":"_d6441eef"};